import { render, staticRenderFns } from "./SkillFilter.vue?vue&type=template&id=47021e96&scoped=true"
import script from "./SkillFilter.vue?vue&type=script&lang=ts"
export * from "./SkillFilter.vue?vue&type=script&lang=ts"
import style0 from "./SkillFilter.vue?vue&type=style&index=0&id=47021e96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47021e96",
  null
  
)

export default component.exports